module.exports = __webpack_public_path__ + "media/icons/widget-close-8d585fea.png";